import styled from "styled-components";

export const ActivityQRRegisterContainerStyled = styled.div`
  padding: 20px 20px 40px 20px;
  .qr_register_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .activity_img_wrap {
      margin-bottom: 22px;
      border-radius: 12px;
      overflow: hidden;
    }
    .result_section {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 24px 0;
      .result_icon {
        margin-bottom: 20px;
      }
      .result_title {
        margin-bottom: 8px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S21};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .result_sub_title {
        margin-bottom: 8px;
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      }
      .result_activity_name {
        margin-bottom: 24px;
        color: ${({ theme }) => theme.COLORS.PURPLE_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
    }
    .btn_wrap {
      width: 100%;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 20px 40px 20px;
  }
`;
